const type = 'SET_CURRENT_DIMENSIONS';

const setCurrentDimensions = (data) => ({
  type,
  data,
});

export { type };
export default setCurrentDimensions;
